






























import Component, {mixins} from "vue-class-component";
import AuthMixin from "@/mixins/auth.mixin";
import {TrainingMaterialCompletionRow} from "shared/api/routes/report";
import {apiHandler} from "@/services/api-handler";
import {Api} from "shared/api";
import {IMaterial} from "shared/entities/material";

@Component({})
export default class TrainingCompletion extends mixins(AuthMixin) {
    rows: TrainingMaterialCompletionRow[] = [];
    materials: Record<string, IMaterial> = {};

    completed(row: TrainingMaterialCompletionRow) {
        return row.completed.map(mId => {
            if (this.materials[mId].hasQuiz && row.quizScores.hasOwnProperty(mId)) {
                return `${this.materials[mId].title} (${row.quizScores[mId][0]}/${row.quizScores[mId][1]})`;
            } else {
                return this.materials[mId].title;
            }
        }).join(", ");
    }

    async mounted() {
        const materials = await apiHandler(() => Api.material.Get());
        for (const material of materials) this.materials[material.id] = material;
        await this.loadResults();
    }


    async loadResults() {
        this.rows = await apiHandler(() => Api.report.materialCompletion.Get({}));
    }
}

